// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JSmH3","footer":"styles_footer__2Acs8"};